import { useEffect, useRef} from 'react';

import styles from './IODevicesComponent.module.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons'

const IODevicesComponent = ({ selectedVideoDevice, setSelectedVideoDevice, selectedMicDevice, setSelectedMicDevice, videoDevices, micDevices }) => {

    const ref = useRef()

    useEffect(() => {
        ref.current.focus();
    }, []);

    const onClickVideo = (device) => {
        setSelectedVideoDevice(device)
    }

    const onClickMic = (device) => {
        setSelectedMicDevice(device)
    }


    return (
        <div ref={ref} className={styles.component} tabIndex="0" onBlur={() => {}}>
            <div className={styles.category}>
                <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fal['camera-web']} />
                Video
            </div>

            {videoDevices.length > 0 && videoDevices.map((device) => <div className={selectedVideoDevice?.deviceId === device.deviceId ? styles.selectedChoice : styles.choice}
                onClick={() => onClickVideo(device)} key={device.deviceId}>
                <FontAwesomeIcon className={styles.icon} style={{color: selectedVideoDevice?.deviceId === device.deviceId ? "" : "transparent"}} icon={byPrefixAndName.fas['check']} />
                {device.label}
            </div>)}
            {videoDevices.length === 0 && <div className={styles.choice}>
                <FontAwesomeIcon className={styles.icon} style={{color: "transparent"}} icon={byPrefixAndName.fas['check']} />
                No camera found
            </div>}

            <div className={styles.category} style={{borderTop: "1px solid #726FA8"}}>
                <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fal['microphone']} />
                Microphone
            </div>
            {micDevices.map((device) => <div className={selectedMicDevice?.deviceId === device.deviceId ? styles.selectedChoice : styles.choice}
                onClick={() => onClickMic(device)} key={device.deviceId}>
                <FontAwesomeIcon className={styles.icon} style={{color: selectedMicDevice?.deviceId === device.deviceId ? "" : "transparent"}} icon={byPrefixAndName.fas['check']} />
                {device.label}
            </div>)}
        </div>
    );
}

export default IODevicesComponent;
